import React from 'react';
import './TcsoChecklistScreen.css';
import { OvoBullet } from '../common/bullet/OvoBullet';
import { useTcsoScreenContext } from '../../context/TcsoScreenContext';
import { TcsoScreen } from './TcsoScreenManager';
import { useHomePageContext } from '../../context/HomePageContext';
import { useFlags } from 'launchdarkly-react-client-sdk';

export default function TcsoChecklistScreen() {
  const { setTcsoScreenInputs } = useTcsoScreenContext();
  const { homePageState, setHomePageState } = useHomePageContext();

  const { enableAutomatedTcsoElecOnly } = useFlags();

  const startTcso = () => {
    setTcsoScreenInputs({ tcsoScreen: TcsoScreen.TCSO_INVENTORY_CHECK_SCREEN });

    setHomePageState({
      ...homePageState,
      automationInProgress: true,
    });
  };

  return (
    <div className="tcsoScreenContainer">
      {enableAutomatedTcsoElecOnly && (
        <div className="tcsoBody">
          <div className={'hintText'}>*TCSO is currently available for elec meter sites only.</div>
          <div className={'sectionWrapper'}>
            <div className={'sectionTextNote'}>
              You’re about to perform a TCSO for elec. <span className={'ovoGreen'}>Before you start, confirm:</span>
            </div>
            <div className={'marginTop12'}></div>
            <OvoBullet text={'Old hub removed and kept away or placed in your vehicle'}></OvoBullet>
            <OvoBullet text={'New hub successfully birthed'}></OvoBullet>
          </div>
        </div>
      )}
      {enableAutomatedTcsoElecOnly && (
        <div className={'tcsoFooter'}>
          <button className={'tcsoButton'} onClick={startTcso}>
            All set, start TCSO
          </button>
        </div>
      )}
    </div>
  );
}
